import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TCompanyHandlersResponse } from './useGetCompanyHandler';

const useCSMs = () => {
  const { data, error, isLoading, mutate } = useSWR(
    'company-handlers/eligible-csms',
    SWRFetcher({ method: 'GET' })
  );

  return {
    data: data as TCompanyHandlersResponse | undefined,
    error,
    isLoading,
    mutate,
  };
};

export default useCSMs;
